import {
  INewFeeFormValues,
  TFeeRule,
  TFee,
  ICarrier,
} from "../interfaces/configuration";
import { IValidation } from "../interfaces/form";
import { getMerchantsForFeeRule, getCarriersForFeeRule } from "./carriers";
import {
  ALL_CARRIERS_OPTION_ID,
  ALL_MERCHANTS_OPTION_ID,
  ERRORS_MESSAGES,
  GREATER_OR_EQUAL_THAN,
} from "./constants";

const { feeRuleNameRequired, feeRequired, onlyNumbers } = ERRORS_MESSAGES;

export const formValidations: IValidation[] = [
  { id: "name", type: "required", message: feeRuleNameRequired },
  { id: "orderPrice", type: "price", message: onlyNumbers },
  { id: "deliveryPrice", type: "price", message: onlyNumbers },
  { id: "weight", type: "only-numbers", message: onlyNumbers },
  { id: "fee", type: "required", message: feeRequired },
  { id: "fee", type: "price", message: onlyNumbers },
];

export const defaultFeeValues: INewFeeFormValues = {
  name: "",
  orderPriceType: GREATER_OR_EQUAL_THAN as TFeeRule,
  orderPrice: "",
  deliveryPriceType: GREATER_OR_EQUAL_THAN as TFeeRule,
  deliveryPrice: "",
  weightType: GREATER_OR_EQUAL_THAN as TFeeRule,
  weight: "",
  merchants: [],
  carriers: [],
  // merchants: [ALL_MERCHANTS_OPTION_ID],
  // carriers: [ALL_CARRIERS_OPTION_ID],
  fee: "",
};

export const parseFeeToFormValues = (
  selectedFee: TFee,
  allMerchants: number[],
  allCarriers: ICarrier[]
) => {
  const {
    name,
    orderPriceType,
    orderPrice,
    deliveryPriceType,
    deliveryPrice,
    weightType,
    weight,
    fee,
    merchants,
    carriers,
  } = selectedFee || defaultFeeValues;
  return {
    name: String(name ?? ""),
    orderPriceType,
    orderPrice: String(orderPrice ?? ""),
    deliveryPriceType,
    deliveryPrice: String(deliveryPrice ?? ""),
    weightType,
    weight: String(weight ?? ""),
    merchants: getMerchantsForFeeRule(allMerchants, merchants),
    carriers: getCarriersForFeeRule(allCarriers, carriers),
    fee: String(fee ?? ""),
  };
};

export const parseBodyForFeeRuleCreation = (values: INewFeeFormValues) => {
  const {
    name,
    fee,
    weight,
    weightType,
    deliveryPriceType,
    deliveryPrice,
    orderPriceType,
    orderPrice,
    merchants: selectedMerchants,
    carriers: selectedCarriers,
    id,
  } = values;

  return {
    name,
    fee: Number(fee),
    weight: weight ? Number(weight) : null,
    weightType,
    deliveryPrice: deliveryPrice ? Number(deliveryPrice) : null,
    deliveryPriceType,
    orderPrice: orderPrice ? Number(orderPrice) : null,
    orderPriceType,
    merchants: selectedMerchants.find((merchantId) => merchantId === ALL_MERCHANTS_OPTION_ID)
      ? []
      : selectedMerchants.map((merchantId: string) => Number(merchantId)),
    carriers: selectedCarriers.find((carrierId) => carrierId === ALL_CARRIERS_OPTION_ID)
      ? []
      : selectedCarriers,
    id,
  };
};
